<template>
  <q-modal
    :show="showModal"
    :title="$t('settings.workspaces.assignments_v_2.create')"
    :subtitle="$t('settings.workspaces.assignments.select_type')"
    close-button
    @close="close"
  >
    <div class="grid auto-rows-fr grid-cols-2 gap-4">
      <div>
        <router-link :to="{ name: 'workspace.assignments.agent-qa.new', params: { id } }">
          <button-card
            data-testid="agent-qa-btn"
            tag="button"
            :title="$t('settings.workspaces.assignments.agent_qa.title')"
            :description="$t('settings.workspaces.assignments.conversation_qa.description')"
            :data-track-event-name="APPLICATIONS_EVENT_NAMES.ASSIGNMENT_TYPE_SELECTED"
            :data-track-sub-feature-id="APPLICATIONS_SUB_FEATURE_IDS.REVIEW_ASSIGNMENTS"
            data-track-entity-name="agent-qa"
            data-track-click
          />
        </router-link>
      </div>
      <div>
        <div class="h-full">
          <router-link :to="{ name: 'workspace.assignments.reviewer-qa.new', params: { id } }">
            <button-card
              data-testid="reviewer-qa-btn"
              tag="button"
              class="h-full"
              :title="$t('settings.workspaces.assignments.reviewer_qa.title')"
              :description="$t('settings.workspaces.assignments.reviewer_qa.description')"
              :data-track-event-name="APPLICATIONS_EVENT_NAMES.ASSIGNMENT_TYPE_SELECTED"
              :data-track-sub-feature-id="APPLICATIONS_SUB_FEATURE_IDS.REVIEW_ASSIGNMENTS"
              data-track-entity-name="reviewer-qa"
              data-track-click
            />
          </router-link>
        </div>
      </div>
    </div>
  </q-modal>
</template>

<script setup lang="ts">
import ButtonCard from '@/modules/workspace/components/ButtonCard.vue'
import QModal from '@/components/QModal.vue'
import { APPLICATIONS_EVENT_NAMES, APPLICATIONS_SUB_FEATURE_IDS } from '@/tracking/features/applications'

defineProps<{
  id: number
  showModal: boolean
}>()

const emit = defineEmits<{
  close: []
}>()

const close = () => {
  emit('close')
}
</script>
